import React from 'react';
import { ListOl } from 'styled-icons/boxicons-regular/ListOl';

function ListOrderedIcon(props) {
  return (
    <ListOl {...props} className={'icon'} />
  );
}

export default ListOrderedIcon;
